
import { Component, Input, OnInit } from '@angular/core';

import {
  faSearch,
  faFileInvoiceDollar,
  faSpinnerThird,
  faUserShield,
  faUsdSquare,
  faFileContract,
  faUsers
} from '@fortawesome/pro-light-svg-icons';

import { GoToService, GoToEntityType } from './go-to.service';

@Component({
  selector: 'dx-go-to-input',
  templateUrl: './go-to-input.component.html',
  styleUrls: ['./go-to-input.component.scss']
})
export class GoToInputComponent implements OnInit {
  @Input() dark = false;
  @Input() placement = 'bottom-right bottom-left top-right bottom-left';
  faSearch = faSearch;
  faSpinnerThird = faSpinnerThird;
  faFIleInvoiceDollar = faFileInvoiceDollar;
  faUserShield = faUserShield;
  faUsdSquare = faUsdSquare;
  faFileContract = faFileContract;
  faUsers = faUsers;
  placeholder = 'go to...';

  constructor(public goToService: GoToService) { }

  ngOnInit() { }

  onBlur() {
    this.goToService.searching = false;
    this.placeholder = 'go to...';
  }

  onFocus($event) {
    this.placeholder = 'enter a name, account, policy, or claim';
    this.goToService.onFocus($event.target.value);
  }

  navigate($event) {
    $event.preventDefault();
    this.goToService.onSelect($event.item);
  }

  goToSearch() {
    this.goToService.navigateToSearch();
  }

  categoryIcon(goToEntityType: GoToEntityType) {
    switch (goToEntityType) {
      case GoToEntityType.Account:
        return this.faUserShield;
        break;
      case GoToEntityType.Billing:
        return this.faUsdSquare;
        break;
      case GoToEntityType.Claim:
        return this.faFIleInvoiceDollar;
        break;
      case GoToEntityType.Policy:
        return this.faFileContract;
        break;
      case GoToEntityType.Agency:
        return this.faUsers;
        break;
    }
  }

}
